const services = [
  {
    id: 'interior',
    title: 'Interior Painting',
    description: 'Refined wall finishes, trim work, ceilings, and full interior transformations that elevate every room.',
    icon: 'ri-paint-brush-line',
    image: 'https://public.readdy.ai/ai/img_res/d39a54942840058e0a828cf6e8858525.jpg',
    href: '/services/interior-painting',
    featured: true,
  },
  {
    id: 'exterior',
    title: 'Exterior Painting',
    description: 'Weather-resistant coatings for Illinois conditions — durable finishes designed for lasting curb appeal.',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20exterior%20house%20painting%20of%20luxurious%20Illinois%20suburban%20home%2C%20painters%20applying%20premium%20weather%20resistant%20coating%20to%20beautiful%20two%20story%20home%2C%20clean%20brush%20lines%20on%20siding%20and%20trim%2C%20blue%20sky%20background%2C%20high-end%20residential%20exterior%20transformation&width=600&height=350&seq=svc-ext01&orientation=landscape',
    href: '/services/exterior-painting',
  },
  {
    id: 'cabinet',
    title: 'Cabinet Painting',
    description: 'Factory-style finishes that modernize kitchens and bathrooms without full replacement costs.',
    icon: 'ri-layout-grid-line',
    image: 'https://readdy.ai/api/search-image?query=stunning%20kitchen%20cabinet%20painting%20transformation%2C%20freshly%20painted%20white%20shaker%20cabinets%20with%20flawless%20smooth%20factory%20finish%2C%20luxury%20kitchen%20interior%20with%20gold%20hardware%20accents%2C%20professional%20cabinet%20painting%20results%2C%20clean%20crisp%20lines%2C%20elegant%20modern%20kitchen%2C%20warm%20lighting&width=600&height=350&seq=svc-cab01&orientation=landscape',
    href: '/services/cabinet-painting',
  },
  {
    id: 'commercial',
    title: 'Commercial Painting',
    description: 'Professional environments completed on schedule with minimal operational disruption.',
    icon: 'ri-store-2-line',
    image: 'https://readdy.ai/api/search-image?query=commercial%20office%20space%20professional%20painting%2C%20modern%20corporate%20interior%20with%20freshly%20painted%20smooth%20walls%20in%20sophisticated%20neutral%20colors%2C%20professional%20painting%20crew%20working%20efficiently%20in%20commercial%20building%2C%20clean%20organized%20workspace%2C%20high-end%20business%20environment%20illinois&width=600&height=350&seq=svc-com01&orientation=landscape',
    href: '/services/commercial-painting',
  },
  {
    id: 'hoa',
    title: 'HOA Painting',
    description: 'Coordinated painting programs for homeowner associations and multi-unit residential communities.',
    icon: 'ri-community-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20HOA%20community%20exterior%20painting%2C%20uniform%20fresh%20paint%20on%20multiple%20premium%20residential%20buildings%20in%20a%20homeowners%20association%20community%2C%20clean%20coordinated%20color%20scheme%2C%20professional%20large-scale%20painting%20project%2C%20illinois%20suburban%20community%20painted%20homes&width=600&height=350&seq=svc-hoa01&orientation=landscape',
    href: '/services/hoa-painting',
  },
  {
    id: 'new-construction',
    title: 'New Construction',
    description: 'Full painting packages for new builds — from primer to final coat, on schedule with your contractor.',
    icon: 'ri-building-4-line',
    image: 'https://readdy.ai/api/search-image?query=new%20construction%20home%20interior%20painting%2C%20fresh%20clean%20walls%20being%20painted%20in%20brand%20new%20residential%20build%2C%20professional%20painters%20in%20spotless%20new%20construction%20home%20with%20open%20floor%20plan%2C%20warm%20neutral%20color%20palette%2C%20premium%20finish%20quality%2C%20illinois%20new%20home%20construction&width=600&height=350&seq=svc-nc01&orientation=landscape',
    href: '/services/new-construction',
  },
];

export default function ServicesOverview() {
  return (
    <section id="services" className="bg-charcoal-800 py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Section Header */}
        <div className="mb-14">
          <span className="font-sans text-gold text-xs tracking-[0.3em] uppercase">What We Do</span>
          <h2 className="font-serif text-warm-white text-4xl md:text-5xl mt-3 mb-2">Our Services</h2>
          <div className="w-24 h-0.5 bg-gold" />
        </div>

        {/* Top row: featured large + 2 small */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5 mb-5">
          {/* Featured large card */}
          <div className="lg:col-span-3 group relative rounded-2xl overflow-hidden cursor-pointer h-[460px]">
            <img
              src={services[0].image}
              alt="Interior painting Elk Grove Village Illinois"
              title="Interior painting Elk Grove Village IL"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/90 via-charcoal-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="w-6 h-6 flex items-center justify-center mb-3">
                <i className={`${services[0].icon} text-gold`} style={{ fontSize: '20px' }} />
              </div>
              <h3 className="font-serif text-warm-white text-2xl mb-2">{services[0].title}</h3>
              <p className="font-sans text-warm-muted text-sm leading-relaxed mb-4 max-w-xs">{services[0].description}</p>
              <a href={services[0].href} className="inline-flex items-center gap-2 text-gold font-sans text-sm hover:gap-3 transition-all duration-200 cursor-pointer">
                Learn More
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" style={{ fontSize: '14px' }} />
                </div>
              </a>
            </div>
          </div>

          {/* Right column */}
          <div className="lg:col-span-2 flex flex-col gap-5">
            {services.slice(1, 3).map((service) => (
              <div key={service.id} className="group relative rounded-2xl overflow-hidden cursor-pointer flex-1 min-h-[216px]">
                <img
                  src={service.image}
                  alt={`${service.title} Elk Grove Village Illinois`}
                  title={`${service.title} IL`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-charcoal-900/85 via-charcoal-900/50 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-center p-6">
                  <div className="w-5 h-5 flex items-center justify-center mb-2">
                    <i className={`${service.icon} text-gold`} style={{ fontSize: '16px' }} />
                  </div>
                  <h3 className="font-serif text-warm-white text-xl mb-1">{service.title}</h3>
                  <p className="font-sans text-warm-muted text-xs leading-relaxed mb-3 max-w-[240px]">{service.description}</p>
                  <a href={service.href} className="inline-flex items-center gap-1 text-gold font-sans text-xs hover:gap-2 transition-all duration-200 cursor-pointer">
                    Learn More
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line" style={{ fontSize: '12px' }} />
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom row: 3 equal cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {services.slice(3).map((service) => (
            <div key={service.id} className="group relative rounded-2xl overflow-hidden cursor-pointer h-[220px]">
              <img
                src={service.image}
                alt={`${service.title} Illinois`}
                title={`${service.title} IL`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-charcoal-900/85 via-charcoal-900/40 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-center p-7">
                <div className="w-5 h-5 flex items-center justify-center mb-2">
                  <i className={`${service.icon} text-gold`} style={{ fontSize: '16px' }} />
                </div>
                <h3 className="font-serif text-warm-white text-xl mb-1">{service.title}</h3>
                <p className="font-sans text-warm-muted text-xs leading-relaxed mb-3 max-w-[280px]">{service.description}</p>
                <a href={service.href} className="inline-flex items-center gap-1 text-gold font-sans text-xs hover:gap-2 transition-all duration-200 cursor-pointer">
                  Learn More
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line" style={{ fontSize: '12px' }} />
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="mt-12 text-center">
          <a
            href="#quote"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-gold text-charcoal-900 font-sans font-medium text-sm px-8 py-4 rounded-full hover:bg-gold-light transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Request Your Free Estimate
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" style={{ fontSize: '14px' }} />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
